import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { fieldLabelSx, fieldWrapperSx } from './styles';

interface FieldFrameProps {
  label?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
}

const FieldFrame = (props: FieldFrameProps) => {
  const { label, htmlFor, children } = props;

  return (
    <Box sx={fieldWrapperSx}>
      {label && (
        <Box component="label" htmlFor={htmlFor} sx={fieldLabelSx}>
          {label}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default FieldFrame;
